// Module
var code = "<div class=\"internal-errors-containers\"> <div class=\"fatal-content\"> <div class=\"header\"> An internal server error message has occured in MyCRM. We are working on <br/> getting this fixed as soon as we can. Please either submit this via email <br/> submission method or try again later. </div> </div> </div> ";
// Exports
module.exports = code;